import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import Modal from '../../../../../../common/react/components/modal'
import Localization from '../../../../../../common/edlio-js/models/BackendLocalization'
import Button from '../../../../../../common/react/components/button'

const HelperText = styled.p`
  margin: 0 0 0.75em;
`

const OptionsTextArea = styled.textarea`
  width: 30em;
  min-height: 14em;
  font-family: monospace;
  resize: vertical;
  color: #000000 !important;
`

const StatusLine = styled.div`
  margin-top: 0.5em;
`

/**
 * BulkEditOptionsModal lets users edit an option list as newline-delimited text
 * instead of one option at a time. The textarea is seeded with the current
 * options each time the modal opens; on confirm the parsed, non-empty lines are
 * handed back to the caller (which replaces the field's option list).
 */
class BulkEditOptionsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      localization: new Localization(props.localization ? props.localization : window.edlio.localizations),
      text: (props.options || []).join('\n')
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
  }

  componentDidUpdate(prevProps) {
    // Re-seed the textarea with the field's current options whenever the modal opens
    if (!prevProps.visible && this.props.visible) {
      this.setState({ text: (this.props.options || []).join('\n') })
    }
  }

  parseLabels() {
    return this.state.text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
  }

  handleChange(event) {
    this.setState({ text: event.target.value })
  }

  handleConfirm() {
    this.props.onConfirm(this.parseLabels())
  }

  render() {
    const { visible, onClose } = this.props
    const { localization } = this.state

    const count = this.parseLabels().length

    return (
      <Modal
        title={localization.localize('Bulk Edit')}
        visible={visible}
        hideCallback={onClose}
      >
        <div className="page" style={{ maxWidth: '36em' }}>
          <HelperText>
            {localization.localize('Paste your options below — one per line. Empty lines are ignored.')}
          </HelperText>

          <OptionsTextArea
            autoFocus
            value={this.state.text}
            onChange={this.handleChange}
          />

          <StatusLine>
            {count} {localization.localize(count === 1 ? 'option' : 'options')}
          </StatusLine>
        </div>

        <footer style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            className="secondary button"
            style={{ boxShadow: 'none' }}
            onClick={onClose}
          >
            <span>{localization.localize('Cancel')}</span>
          </Button>

          <Button
            width="6.5em"
            className="button"
            onClick={this.handleConfirm}
          >
            <span>{localization.localize('Confirm')}</span>
          </Button>
        </footer>
      </Modal>
    )
  }
}

BulkEditOptionsModal.propTypes = {
  visible: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  localization: PropTypes.any
}

export default BulkEditOptionsModal


// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/components/modals/bulk-edit-options-modal.js